var render = function render(){var _vm=this,_c=_vm._self._c;return _c('OEEHistoryChart',{attrs:{"type":_vm.type,"annotations":_vm.annotations,"series":_vm.series,"labels":_vm.areNewLabelsOk ? _vm.labels : _vm.oldLabels,"height":_vm.height,"max":_vm.max}})
}
var staticRenderFns = []

export { render, staticRenderFns }